import React, { useEffect, useState } from "react";
import { Check } from "lucide-react";
import axios from "axios";

const FirstCard = () => {
  const [aboutData, setAboutData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAboutData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/about/get-about`);
        if (response.data.success && response.data.data.length > 0) {
          setAboutData(response.data.data[0]);
        }
      } catch (error) {
        console.error("Error fetching about data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchAboutData();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="animate-pulse text-gray-400">Loading...</div>
      </div>
    );
  }

  if (!aboutData) return null;

  return (
    <div className="bg-gradient-to-b from-gray-50 to-white pt-10 px-4 md:px-10">
      <div className="w-full mx-auto">
        {/* Header Section */}
        <div className="text-center mb-6">
          <span className="inline-block px-4 py-2 bg-red-50 text-red-600 rounded-full text-sm font-semibold tracking-wide uppercase mb-4">
            {aboutData.title}
          </span>
          <h1 className="text-2xl md:text-4xl font-semibold text-gray-900 mb-6 leading-tight">
            {aboutData.subtitle}
          </h1>
        </div>

        {/* Description Section */}
        <div className="text-justify">
          <div className="prose prose-lg max-w-none">
            {aboutData.description?.map((desc, idx) => (
              <p
                key={idx}
                className="text-gray-600 leading-relaxed text-lg mb-6"
                dangerouslySetInnerHTML={{ __html: desc }}
              />
            ))}
          </div>
        </div>

        {/* Key Points Sections */}
        {aboutData.keyPoints?.map((section, idx) => (
          <div
            key={idx}
            className={`mb-10 ${
              idx % 2 === 0 ? "" : "bg-white"
            } rounded-2xl text-justify`}
          >
            <div className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${
              idx % 2 === 0 ? "" : "lg:grid-flow-dense"
            }`}>
              {/* Content */}
              <div className={idx % 2 === 0 ? "lg:order-1" : "lg:order-2"}>
                <h2 className="text-3xl font-semibold text-gray-900 mb-8">
                  {section.heading}
                </h2>
                <div className="space-y-5">
                  {section.points?.map((point, pidx) => (
                    <div
                      key={pidx}
                      className="flex items-start"
                    >
                      <div className="flex-shrink-0 mt-1">
                        <div className="w-6 h-6 rounded-full bg-blue-100 flex items-center justify-center group-hover:bg-blue-500 transition-colors duration-300">
                          <Check className="w-4 h-4 text-blue-600 group-hover:text-white transition-colors duration-300" />
                        </div>
                      </div>
                      <div
                        className="ml-4 text-gray-700 text-base md:text-lg leading-relaxed"
                        dangerouslySetInnerHTML={{ __html: point }}
                      />
                    </div>
                  ))}
                </div>
              </div>

              {/* Image */}
              <div className={idx % 2 === 0 ? "lg:order-2" : "lg:order-1"}>
                {aboutData.images?.[idx] && (
                  <div className="relative group overflow-hidden">
                    <img
                      className="w-full h-auto object-cover"
                      src={aboutData.images[idx]}
                      alt={section.heading}
                    />
                    {/* <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div> */}
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FirstCard;
